import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';
import { LeaderBoard } from '../services/backendService/types';

export const gameCacheKey = 'game';

function useGameLeaderBoard({
  slideId,
  gameId,
  includeAll,
  isAuthenticated,
}: {
  slideId: string;
  gameId: string;
  includeAll?: boolean;
  isAuthenticated: boolean;
}) {
  const { data, isFetching } = useQuery<LeaderBoard | undefined>(
    ['game-leaderboard', slideId, gameId, 'top5'],
    _ => {
      if (isAuthenticated === false)
        return backendService.instance.game.retrievePublicLeaderBoard(
          slideId,
          gameId,
          false,
        );
      return backendService.instance.game.retrieveLeaderBoard(slideId, gameId, false);
    },
  );

  const { data: allData, isFetching: isFetchingAll } = useQuery<LeaderBoard | undefined>(
    ['game-leaderboard', slideId, gameId, 'all'],
    _ => {
      if (isAuthenticated === false)
        return backendService.instance.game.retrievePublicLeaderBoard(
          slideId,
          gameId,
          true,
        );
      return backendService.instance.game.retrieveLeaderBoard(slideId, gameId, true);
    },
  );

  return {
    data: includeAll ? allData : data,
    isLoading: includeAll ? isFetchingAll : isFetching,
  };
}

export default useGameLeaderBoard;
